import { ContentBlocText, ContentBlocWidget } from 'interfaces';

export const CONTENT_BLOC: {
  TEXT: ContentBlocText;
  WIDGET: ContentBlocWidget;
} = Object.freeze({
  TEXT: 'ContentBlocText',
  WIDGET: 'ContentBlocWidget',
});
